'use client';

import Header from '@components/header/header.view';
import Logo from '@components/logo';
import { usePreview } from 'cms/clients/sanity.preview';
import siteSettingsQuery from 'queries/site-settings-query';
import type { ReactElement } from 'react';
import React from 'react';
import type { SiteSettings } from 'types/site-settings';

function PreviewHeader(): ReactElement {
  const siteSettings: SiteSettings | null =
    usePreview<SiteSettings>(siteSettingsQuery);

  if (siteSettings === null) {
    throw new Error('PreviewHeader could not find siteSettings');
  }

  return (
    <Header
      links={siteSettings.navigation}
      logo={
        <Logo
          image={
            typeof siteSettings.logo !== 'undefined' &&
            siteSettings.logo !== null
              ? {
                  src: siteSettings.logo.url,
                  height: siteSettings.logo.dimensions.height,
                  width: siteSettings.logo.dimensions.width,
                }
              : undefined
          }
          text={
            typeof siteSettings.logo === 'undefined'
              ? siteSettings.title
              : undefined
          }
        />
      }
    />
  );
}

export default PreviewHeader;
